/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Endpoint_Row_LatencyInputs */

const en_endpoint_row_latency = /** @type {(inputs: Endpoint_Row_LatencyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} p50`)
};

const zh_hans1_endpoint_row_latency = /** @type {(inputs: Endpoint_Row_LatencyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`p50 ${i?.value}`)
};

const pt_br2_endpoint_row_latency = /** @type {(inputs: Endpoint_Row_LatencyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} p50`)
};

const es_endpoint_row_latency = /** @type {(inputs: Endpoint_Row_LatencyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} p50`)
};

const fr_endpoint_row_latency = /** @type {(inputs: Endpoint_Row_LatencyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} p50`)
};

const de_endpoint_row_latency = /** @type {(inputs: Endpoint_Row_LatencyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} p50`)
};

const ru_endpoint_row_latency = /** @type {(inputs: Endpoint_Row_LatencyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} p50`)
};

const it_endpoint_row_latency = /** @type {(inputs: Endpoint_Row_LatencyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} p50`)
};

/**
* | output |
* | --- |
* | "{value} p50" |
*
* @param {Endpoint_Row_LatencyInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_row_latency = /** @type {((inputs: Endpoint_Row_LatencyInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Row_LatencyInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_row_latency(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_row_latency(inputs)
	if (locale === "es") return es_endpoint_row_latency(inputs)
	if (locale === "fr") return fr_endpoint_row_latency(inputs)
	if (locale === "de") return de_endpoint_row_latency(inputs)
	if (locale === "ru") return ru_endpoint_row_latency(inputs)
	if (locale === "it") return it_endpoint_row_latency(inputs)
	return en_endpoint_row_latency(inputs)
});